import { render, staticRenderFns } from "./CertificadoGuia.vue?vue&type=template&id=f00f8fde&scoped=true&"
import script from "./CertificadoGuia.vue?vue&type=script&lang=js&"
export * from "./CertificadoGuia.vue?vue&type=script&lang=js&"
import style0 from "./CertificadoGuia.vue?vue&type=style&index=0&id=f00f8fde&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f00f8fde",
  null
  
)

export default component.exports